import { identity, map } from 'underscore';

// @aiContributed-MAPFuse-2026-01-29
// Updated to include SourceType in bulk upload payload for text assets
const textAssetMapper = assets => JSON.stringify(assets.map((asset) => {
  const result = { text: asset.Asset.Text };
  if (asset.Asset.SourceType) {
    result.sourceType = asset.Asset.SourceType;
  }
  return result;
}));

export const AssetGroup = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Asset Group',
    },
    Name: {
      'bulk-upload-header': 'Asset Group',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    BusinessName: {
      'bulk-upload-header': 'Business Name',
    },
    Path1: {
      'bulk-upload-header': 'Path 1',
      bulkDeleteValueIfEmpty: true,
    },
    Path2: {
      'bulk-upload-header': 'Path 2',
      bulkDeleteValueIfEmpty: true,
    },
    CallToAction: {
      'bulk-upload-header': 'Call To Action',
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': identity,
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    AssetContext: {
      'bulk-upload-header': 'Asset Context',
    },
    Headlines: {
      'bulk-upload-header': 'Headlines',
      'bulk-upload-mapper': textAssetMapper,
    },
    LongHeadlines: {
      'bulk-upload-header': 'Long Headlines',
      'bulk-upload-mapper': textAssetMapper,
    },
    Descriptions: {
      'bulk-upload-header': 'Descriptions',
      'bulk-upload-mapper': textAssetMapper,
    },
    Images: {
      type: 'string',
    },
    StartDate: {
      'bulk-upload-header': 'Start Date',
    },
    EndDate: {
      'bulk-upload-header': 'End Date',
    },
    Videos: {
      type: 'string',
    },
    PerformancePrediction: {
      'bulk-upload-header': 'Performance Prediction',
      'bulk-upload-mapper': function (value) {
        return value ? JSON.stringify(value) : '';
      },
    },
  },
};
